import type { ISupportCourse } from "@bbj-types/supportCourse";
import type { IUser } from "@bbj-types/user";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { supportCourseAxios } from "./axios";

export type TPatchSupportCourseResponse = Omit<ISupportCourse, "sessions" | "owner"> & {
  owner: Pick<IUser, "_id" | "name" | "firstName" | "lastName">;
};

export type TPatchSupportCourseRequest = Partial<ISupportCourse>;
export const usePatchSupportCourse = () => {
  const [state, execute, cancel] = supportCourseAxios<TPatchSupportCourseResponse, TPatchSupportCourseRequest>(
    {
      url: "/supportCourses",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (supportCourseId: ObjectId, data: TPatchSupportCourseRequest) => {
      return execute({
        url: `supportCourses/${supportCourseId}`,
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
